module.exports = __webpack_public_path__ + "img/项目场景_客户考察.c1223ae0.jpg";